module.exports = __webpack_public_path__ + "static/media/hall-CSA.e2c97ff0.svg";